import ManageExclusion from '@/components/parametres/parametre/custom_exclusions/manage-exclusion'
import store_config from '@/store/mods/parametres/config'

export default {
    name: 'custom-exclusions',
    components: {
        ManageExclusion
    },
    props: [],
    data() {
        return {
            user_info: {},
            exclusions: [],
            is_loading: true,
            is_empty: false,
            is_load_error: false
        }
    },

    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },

    mounted() {
        this.user_info = {
            id: this.userCredentials.user.id,
            nom: this.userCredentials.user.name,
        }

        Array.prototype.groupBy = function (key) {
            return this
                .reduce((hash, obj) => {
                    if (obj[key] === undefined) return hash;
                    return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                }, {})
        };

        this.fetchCustomExclusions()
    },

    methods: {
        fetchCustomExclusions() {
            this.is_loading = true
            this.is_load_error = false
            this.exclusions = []
            
            store_config.selectCustomExclusions().then((response) => {
                if (response.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                    this.groupExclusionByTypePrestation(response)
                }
                
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_load_error = true
            })
        },

        groupExclusionByTypePrestation(exclusions) {
            const tmp_grouped_exclusions = exclusions.groupBy('type_prestation')

            for (const key in tmp_grouped_exclusions) {
                const tmp_grp = {
                    type_prestation: this.convertDataTypeToLibelle(key),
                    prestations: tmp_grouped_exclusions[key]
                }

                this.exclusions.push(tmp_grp)
            }
        }
    }
}